import { render, staticRenderFns } from "./RosterEditModal.vue?vue&type=template&id=7084478c"
import script from "./RosterEditModal.vue?vue&type=script&lang=ts"
export * from "./RosterEditModal.vue?vue&type=script&lang=ts"
import style0 from "./RosterEditModal.vue?vue&type=style&index=0&id=7084478c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports